import TheGrid from '@/views/stars/ws_objectives/grid'
import Edit from '@/views/stars/ws_objectives/edit'
import Importer from '@/views/stars/ws_objectives/import'

export default {
  path: '/stars/ws_objectives',
  redirect: '/stars/ws_objectives/index',
  name: 'ws_objectives',
  meta: {
    auth: {
      redirect: {
        name: 'ws_objectives.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'WS Objectivos'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'ws_objectives.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'ws_objectives.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'import',
    name: 'ws_objectives.import',
    component: Importer,
    meta: {
      auth: true,
      label: 'Importar'
    }
  }, {
    path: 'edit/:id',
    name: 'ws_objectives.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
